class WishlistListMember extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.actioned = false

    this.onRemoveClicked = this.onRemoveClicked.bind(this)
    this.listeners.add(this.els.remove.element, 'click', this.onRemoveClicked)
  }

  async onRemoveClicked (event) {
    event.preventDefault()

    if (this.actioned) return
    this.actioned = true

    const apiResult = await window.BAO.wishlist.removeMember(
      this.listId,
      this.collaboratorId,
      this.token,
    )

    this.externalEls.collaborators.element.setAttribute(
      'aria-hidden',
      apiResult.collaborators > 0 ? 'false' : 'true',
    )
    this.externalEls.collaboratorsText.element.innerHTML =
      apiResult.collaborators_html
    this.externalEls.membersDescription.element.innerHTML =
      apiResult.members_description_html

    this.remove()

    if (apiResult.collaborators === 0) {
      document.body.dispatchEvent(
        new CustomEvent('site-modal:close', {
          bubbles: true,
          detail: { id: 'wishlist-list-manage' },
        }),
      )
    }
  }

  get listId () {
    return this.dataset.listId
  }

  get collaboratorId () {
    return this.dataset.collaboratorId
  }

  get token () {
    return window.BAO.wishlist.token
  }
}

if (!window.customElements.get('wishlist-list-member')) {
  window.customElements.define('wishlist-list-member', WishlistListMember)
}
